import {Component} from 'react';
import {listeRessources , initialRessources , ressourcesFamille } from './lib/liste-ressources';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
import {MontantInput} from './montant-input';
import {MontantsDetailles} from './details-montant-input';
import {MontantsLastThreeMonths} from './last-three-months';
import {getMonthText , lastThreeMonths} from './lib/utils';

import arrowLeft from './../../img/arrow-pointing-left.png';
import InfoBulle from './info';

/* Les montants sont saisis en net alors qu'OpenFisca attend des bruts. */
const TAUX_NET_SUR_BRUT_SALAIRE = 0.79;
const TAUX_NET_SUR_BRUT_CHOMAGE = 1 - ((0.062 + 0.005) * 0.9825 + 0.028);
/* CSG non déductible (2,4 %) + CRDS (0,5 %) sur 98,25 % du brut : écart entre net à payer et net imposable. */
const TAUX_CSG_CRDS_NON_DEDUCTIBLE = 0.029 * 0.9825;


class Ressources extends Component {
	constructor(props) {
		super(props);
		this.state = {
			typeRessources : Object.keys(listeRessources),
			switchTypeRessource : {},
			currentRessIndex : 0,
			currentIndividu : "demandeur",
			listeIndividus : ["demandeur"],
			personnesACharge :{},
			ressources : initialRessources(),
			enfantsAyantRessources : false,
			questionPersonne : {
				"demandeur" : "Percevez-vous",
				"conjoint": "Votre conjoint perçoit-il"
			},
		};
		this.state.definedRessources =[];
		this.state.typeRessources.forEach( (type) =>{
			this.state.switchTypeRessource[type] = false;
		})

		/* Init listeIndividus*/
		if (this.props.conjoint  !== undefined) {
			this.state.listeIndividus.push("conjoint")
		}

		if ( this.props.individus ) {
			Object.keys(this.props.individus).forEach((individu)=>{
				if (individu !== 'demandeur' && individu !== 'conjoint') {
					this.state.personnesACharge[individu] = this.props.individus[individu];
				}
			});
			this.state.listeIndividus = [ ...this.state.listeIndividus ,...Object.keys(this.state.personnesACharge)];
		}
		const date = new Date();
		const previousYearDateString =  (date.getFullYear()-1) + '-' + ('0' + (date.getMonth()+1).toString()).slice(-2);
		this.dateNmoins1 = getMonthText(previousYearDateString);
		this.yearMinOne =  date.getFullYear()-1;
		const [year,month] = [date.getFullYear() , date.getMonth()+1 ]

		this.thisMonth = `${year}-${month.toString().padStart(2,"0")}`;
		


	}
	prevRessources = () => this.setState( (previous) => {
		let prev = previous.currentRessIndex-1;
		if ( prev=== this.state.typeRessources.indexOf('revenu_pro_non_salarie')) {
			prev--;
			document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
		}
		return { currentRessIndex : prev}}
	);

	validInputs = () => {
		const currentRessIndex =this.state.currentRessIndex;
		const currentRessType = this.state.typeRessources[currentRessIndex];
		const revenus= listeRessources[currentRessType];

		const noError = revenus.ressources.every((ressource)=>{
			return !this.state.ressources[ressource.name].invalid;
		});

		if (!noError){
			this.setState(()=> ({ressourceInputError: "Vérifiez les ressources saisies."}) );
			return false;
		} else {
			this.setState(()=> ({ressourceInputError: ""}) );
			return true;
		}
	}

	nextForm = ()=>{
		if ( !this.validInputs()) {
			return false;
		}
		document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
		if (this.state.currentRessIndex !== this.state.typeRessources.length-1){
			this.setState( (previous)=>{
				let newIndex  = previous.currentRessIndex + 1;
				if ( newIndex === this.state.typeRessources.indexOf('revenu_pro_non_salarie')) {
					newIndex++;
				}
				return { currentRessIndex : newIndex };
			});
		}else {
			var data = {
				famille : this.props.famille
			};
			
			if (this.state.currentIndividu !== "demandeur" && this.state.currentIndividu !== "conjoint"){
				data.individus = this.state.personnesACharge;
				data.individus[this.state.currentIndividu].ressources = {};
			}else {
				data[this.state.currentIndividu]= {
					ressources : {}
				};
			}

			let definedRessources = this.state.definedRessources;
			
			/* Assigne les ressources a l'individu */
			Object.keys(this.state.ressources).forEach(
				(ressourceName)=> {
					var ressources = {...this.state.ressources};
					
					const ressTotal = Object.keys(ressources[ressourceName]).reduce(
						(total , date)=>{
							return (typeof ressources[ressourceName][date] !== 'number')
								? total :total + ressources[ressourceName][date];
						}, 0);
					const revenuProNonSalarie = [
					        'tns_auto_entrepreneur_chiffre_affaires',
					        'tns_micro_entreprise_chiffre_affaires',
					        'tns_autres_revenus',
					       
					    ];
					var individu;

					
					if (ressTotal > 0) {
						
						if ( ressourceName === 'revenus_locatifs'){
							ressources.salaire_imposable =  typeof ressources.salaire_imposable === 'undefined'?
								{} : ressources.salaire_imposable ;

							Object.keys(ressources.revenus_locatifs).forEach((date)=>{
								if ( date!== 'show' && date !=='details'){
									let montant = ressources.revenus_locatifs[date];
									
									if ( !isNaN(ressources.salaire_imposable[date])){
										ressources.salaire_imposable[date] += montant;
									}else {
										ressources.salaire_imposable[date] = montant;
									}
								}
							});

						}

						if ( revenuProNonSalarie.includes(ressourceName)) {
							ressources[ressourceName][this.yearMinOne-1] = ressources[ressourceName][this.yearMinOne];
						}

						if ( ressourceName === 'revenus_locatifs'){
							ressourceName = 'salaire_imposable';
						}
						
						if ( ressourceName === 'salaire_net' && ressources[ressourceName].details=== true  ) {
							let date = new Date();
							let yearMinTwo = date.getFullYear()-2;
							let curMonthString= (date.getMonth()+1).toString().padStart(2,"0");
							let dateString = `${yearMinTwo}-${curMonthString}`;
							ressources.salaire_net = ressources[ressourceName][dateString];
						}

						else if (ressourceName === "salaire_net" && ressources[ressourceName].details=== false ){
							let date = new Date();
							let _prevMonth = ((((12+date.getMonth()-1)%12))+1).toString().padStart(2, "0"); // not date.getMonth()-1 
							let prevMonthYear  = ( date.getMonth() ) > 0 ? parseInt(date.getFullYear()) : parseInt(date.getFullYear())-1;
							let previousMonth = `${prevMonthYear}-${_prevMonth}`;
							ressources.salaire_net =  ressources.salaire_imposable[previousMonth];
						}

						if ( ressourceName === "tns_benefice_exploitant_agricole" ) {
							data[this.state.currentIndividu].activite = "actif"
						}
						
						if ( this.state.currentIndividu === "demandeur" || this.state.currentIndividu==="conjoint"){
							individu = data[this.state.currentIndividu];
							data[this.state.currentIndividu].ressources[ressourceName] = ressources[ressourceName];
						} else {
							individu = data.individus[this.state.currentIndividu];
							data.individus[this.state.currentIndividu].ressources[ressourceName] = ressources[ressourceName];
						}

						if (!definedRessources.includes(ressourceName)){
							definedRessources.push(ressourceName);
						}

						if ( revenuProNonSalarie.includes(ressourceName)) {
							this.getTypeActivite ( individu , ressourceName, ressources[ressourceName].type_activite);

							delete ressources[ressourceName].type_activite;
							delete ressources[ressourceName].continuation;
							delete ressources[ressourceName].details;
							delete ressources[ressourceName].show;
							delete ressources[ressourceName].opt_type_activite;
						}

												
					}
					
				}
			);

			/* Assigne les ressources de famille  a l'entité famille*/
			ressourcesFamille.forEach( (ressourceName)=>{
				if ( data.famille[ressourceName] !== null && typeof data.famille[ressourceName] !== 'undefined' ) {
					return false;
				}
				var ressourceIndividu;
				if ( this.state.currentIndividu === "demandeur" || this.state.currentIndividu==="conjoint"){
					ressourceIndividu = data[this.state.currentIndividu].ressources ;

				} else {
					ressourceIndividu = data.individus[this.state.currentIndividu].ressources ;

				}


				if (typeof ressourceIndividu[ressourceName] !== 'undefined'){
					data.famille[ressourceName] = {...ressourceIndividu[ressourceName]};
					delete ressourceIndividu[ressourceName];
				}else {
					data.famille[ressourceName] = null;
				}
			});

			const indexIndividu = this.state.listeIndividus.indexOf(this.state.currentIndividu);
			if ( definedRessources.length > 0 ) {
				data.definedRessources = definedRessources;
				//console.log(data.definedRessources);
			}

			if ( indexIndividu  === this.state.listeIndividus.length-1 ){
				this.props.validateStep(data);
			} else {
				this.setState(({listeIndividus})=>{
					const nextIndividu = listeIndividus[indexIndividu+1];
					var newSwitchTypeRessource = {};
					this.state.typeRessources.forEach( (type) =>{
							newSwitchTypeRessource[type] = false;
						})
					if ( ( nextIndividu !== 'demandeur' && nextIndividu !== 'conjoint') && this.state.personnesACharge[nextIndividu].hasRessources === undefined) {
						
						return {
							enfantsAyantRessources : true,
							ressources : initialRessources(),
							currentRessIndex :0,
							currentIndividu:nextIndividu,
							switchTypeRessource :newSwitchTypeRessource,
						}
					}
					return {
						currentIndividu:nextIndividu,
						ressources : initialRessources(),
						currentRessIndex :0,
						switchTypeRessource : newSwitchTypeRessource,
					};
				});
				this.props.validateStep(data , true); // update without passing to next step
			}			
		}
	}

	getTypeActivite = (individu ,ressourceName , typeActivite) => {
		if ( typeActivite !== undefined ) {
			switch(ressourceName){
			  case 'tns_auto_entrepreneur_chiffre_affaires':
			  	individu.tns_auto_entrepreneur_type_activite = typeActivite;
				break
			  case 'tns_micro_entreprise_chiffre_affaires':
			  	individu.tns_micro_entreprise_type_activite = typeActivite;
				break;
			  case 'tns_autres_revenus':
				individu.tns_autres_revenus_type_activite = typeActivite;
				break;
			  default:
			  	break;
			}
		}

		individu.activite = "actif";
 	}

	handleRadioSwitch = (newValue,modelName)=>{
		newValue = JSON.parse(newValue);
		this.setState( ({switchTypeRessource}) => {
			switchTypeRessource[modelName] = newValue;
			return { switchTypeRessource : switchTypeRessource};
		})

	}

	enfantRessourceSwitch = (newValue,modelName)=>{
		newValue = JSON.parse(newValue);
		this.setState( ({personnesACharge}) => {
			personnesACharge[modelName].hasRessources = newValue;
			return { personnesACharge : personnesACharge};
		})

	}

	switchDetails =(ressourceName)=> {
		/* new value has to be defined outside cause setState is called twice */
		const newValue = !this.state.ressources[ressourceName].details;
		this.setState(  ({ressources})=>{
			ressources[ressourceName].details = newValue;
			return {
				ressources : ressources,
			};
		})
	}

	showRessourceInput = (ressourceName)=>{
		
		const newValue = !this.state.ressources[ressourceName].show;
		this.setState(  ({ressources})=>{
			ressources[ressourceName].show = newValue;
			return {
				ressources : ressources,
			};
		})
	}

	changeRessourceMontant = (montant,modelName)=>{
		var thisMonth = this.thisMonth;
		this.setState(({ressources})=>{
			if (modelName === "salaire_net") {
				ressources.salaire_de_base={};
				ressources.salaire_imposable={};
			} else if (modelName === "chomage_net") {
				ressources['chomage_brut'] = {};

			} else if (modelName === "retraite_nette") {
				ressources['retraite_brute'] = {};

			}

			Object.keys(ressources[modelName]).forEach((date)=>{
				if (date !=='details' && date !== 'show' ){
					ressources[modelName][date] = montant;

					if (modelName === "salaire_net") {
						const salaireBrut = montant / TAUX_NET_SUR_BRUT_SALAIRE;
						ressources.salaire_de_base[date] = salaireBrut;
						ressources.salaire_imposable[date] = montant + (salaireBrut * TAUX_CSG_CRDS_NON_DEDUCTIBLE);
					} else if (modelName === "chomage_net") {
						ressources.chomage_brut[date] = montant / TAUX_NET_SUR_BRUT_CHOMAGE;

					} else if (modelName === "retraite_nette") {
						ressources.retraite_brute[date] = montant
						ressources.retraite_brute[thisMonth]= montant;
						//ressources.retraite_nette[date] = parseFloat((montant * 0.926).toFixed(13));
						ressources.retraite_nette[date] = montant;
					}
				}


			});
			
			Object.keys(ressources[modelName]).forEach((date)=>{
				if (modelName === "retraite_nette") {
					ressources.retraite_brute[date] = montant;
					console.log('affectation');
				}
			});


			
			ressources[modelName][thisMonth] = montant;

			return {ressources : ressources};
		});
	}

	captureTypeActivite = ( model,value) =>{
		//tns_auto_entrepreneur_type_activite
		//tns_micro_entreprise_type_activite
		this.setState(({ressources})=>{
			ressources[model].type_activite = value;
			return {ressources : ressources};
		});
		
	}
	
	captureLastThreeMonths = ( montants,ressource)=> {
		//this.setState();
		this.setState(({ressources})=>{
			Object.keys(montants).forEach( (month)=>{
				ressources[ressource][month] = montants[month];
			});
			return {ressources : ressources};
		});
	}
	
	captureYear = ( montant , modelName , year) => {
		this.setState(({ressources})=>{
			if (typeof ressources[modelName] !== 'undefined' ){
				ressources[modelName][year] = montant;
			}
			
			return {ressources:ressources}
		});
	}

	captureContinuationAutoEntrepreneur = ( value) =>{
		const continuation = JSON.parse(value);
		var date = new Date();
		this.setState(({ressources})=>{
			let ressource = ressources.tns_auto_entrepreneur_chiffre_affaires;
			if ( continuation ) {
				let _prevMonth = ((((12+date.getMonth()-1)%12))+1).toString().padStart(2, "0"); // not date.getMonth()-1 
				let prevMonthYear  = ( date.getMonth() ) > 0 ? parseInt(date.getFullYear()) : parseInt(date.getFullYear())-1;
				let previousMonth = `${prevMonthYear}-${_prevMonth}`;
				ressources.tns_auto_entrepreneur_chiffre_affaires[this.thisMonth]  = ressource[previousMonth];
			
			} else {
				delete ressources.tns_auto_entrepreneur_chiffre_affaires[this.thisMonth];
			
			}
			
			ressources.tns_auto_entrepreneur_chiffre_affaires.continuation = continuation;
			return {ressources :ressources};
		})
	}

	formAutoEntrepreneur = () =>{
		let ressource = 'tns_auto_entrepreneur_chiffre_affaires';
		//Vous aurez un chiffre d’affaire non nul en
		return <div className="ressource-input-container fade-in">
				<div className="question-type-activite">
					<label for="tns_auto_entrepreneur_type_activite">Type d'activité</label>
					<select 
						className="type_activite" 
						name={ressource}
						defaultValue = {this.state.ressources[ressource].type_activite}
						onChange ={(e)=>(this.captureTypeActivite(ressource , e.target.value))}
					>
					{this.state.ressources[ressource].opt_type_activite.map((option)=>{
						return <option value={option.value} >{option.label}</option>
					})}
					</select>
				</div>
				
				<MontantsLastThreeMonths
					label="Chiffre d'affaires "
					handler= {this.captureLastThreeMonths}
					model= {ressource}
					name ={ressource}
				/>
				
				<MontantInput 
					name = {ressource}
					model ={this.state.ressources[ressource][this.yearMinOne]}
					modelName={ressource}
					handler= {(montant , modelName)=> (  this.captureYear( montant,modelName,this.yearMinOne))}
				>Chiffre d'affaires {this.yearMinOne}</MontantInput>
				
				<div className="montant-continuation" style={{marginBottom:'55px'}}>
					<RadioBox 
					  name="continuation_chiffre_affaire"
					  options = {{"Oui":true , "Non":false}}
					  handler={this.captureContinuationAutoEntrepreneur}
					  defaultValue={this.state.ressources[ressource].continuation}
					>
					Vous aurez un chiffre d’affaire non nul en {getMonthText(this.thisMonth)}
					</RadioBox>
				</div>

			</div>;
	}
	formExploitantAgricole = ()=>{
		let ressource = 'tns_benefice_exploitant_agricole';

		return <div className="ressource-input-container fade-in saisi-montant">
				
				<MontantInput 
					name = {ressource}
					model ={this.state.ressources[ressource][this.yearMinOne]}
					modelName={ressource}
					handler= {(montant , modelName)=> (  this.captureYear( montant,modelName,this.yearMinOne))}
				>Dernier bénéfice agricole</MontantInput>

			</div>; 
	}
	formMicroEntreprise = ()=>{
		let ressource = 'tns_micro_entreprise_chiffre_affaires';

		return <div className="ressource-input-container fade-in">
				<div className="question-type-activite">
					<label for="tns_auto_entrepreneur_type_activite">Type d'activité</label>
					<select 
						className="type_activite" 
						name={ressource}
						defaultValue = {this.state.ressources[ressource].type_activite}
						onChange ={(e)=>(this.captureTypeActivite(ressource , e.target.value))}
					>
					{this.state.ressources[ressource].opt_type_activite.map((option)=>{
						return <option value={option.value} >{option.label}</option>
					})}
					</select>
				</div>
				
				<MontantInput 
					name = {ressource}
					model ={this.state.ressources[ressource][this.yearMinOne]}
					modelName={ressource}
					handler= {(montant , modelName)=> (  this.captureYear( montant,modelName,this.yearMinOne))}
				>Chiffre d'affaires {this.yearMinOne}</MontantInput>

			</div>;

	}

	formProfessionLiberale = ()=>{
		
		let ressource = 'tns_autres_revenus';

		return <div className="ressource-input-container fade-in">
				<div className="question-type-activite">
					<label for="tns_auto_entrepreneur_type_activite">Type d'activité</label>
					<select 
						className="type_activite" 
						name={ressource}
						defaultValue = {this.state.ressources[ressource].type_activite}
						onChange ={(e)=>(this.captureTypeActivite(ressource , e.target.value))}
					>
					{this.state.ressources[ressource].opt_type_activite.map((option)=>{
						return <option value={option.value} >{option.label}</option>
					})}
					</select>
				</div>
				
				<MontantInput 
					name = {ressource}
					model ={this.state.ressources[ressource][this.yearMinOne]}
					modelName={ressource}
					handler= {(montant , modelName)=> (  this.captureYear( montant,modelName,this.yearMinOne))}
				>Bénéfice sur le dernier exercice clos</MontantInput>

			</div>;
	}
	captureMontantDetailler = ( montants,modelName) => {
		this.setState( ({ressources}) =>{
			ressources[modelName].details = true;
			ressources[modelName].show = true;
			if (modelName === "salaire_net") {
				ressources.salaire_de_base={};
				ressources.salaire_imposable={
					details:true,
				};
			} else if (modelName === "chomage_net") {
				ressources['chomage_brut'] = {};
			} else if (modelName === "retraite_nette") {
				ressources['retraite_brute'] = {
					
				};
			}

			Object.keys(montants).forEach((date)=>{
				const montant = montants[date];
				if (date !=='details' && date !== 'show' ){
					
					ressources[modelName][date] = montant;

					if (modelName === "salaire_net") {
						const salaireBrut = montant / TAUX_NET_SUR_BRUT_SALAIRE;
						ressources.salaire_de_base[date] = salaireBrut;
						ressources.salaire_imposable[date] = montant + (salaireBrut * TAUX_CSG_CRDS_NON_DEDUCTIBLE);
					} else if (modelName === "chomage_net") {
						ressources.chomage_brut[date] = montant / TAUX_NET_SUR_BRUT_CHOMAGE;
						ressources.chomage_net[date] = montant;

					} else if (modelName === "retraite_nette") {
						ressources.retraite_brute = montant;
					}
				}
			});

			return { ressources : ressources};
		});
	}
	submitEnfantsAyantsRessources = ()=>{
		var noRessources = true;
		var enfantsAyantRessources = [];
		Object.keys( this.state.personnesACharge).forEach((individu)=>{

			if ( this.state.personnesACharge[individu].hasRessources ){
				enfantsAyantRessources.push (individu);
				noRessources = false;
			}
			
		});
		if (noRessources) {
			this.props.validateStep()
		}else {
			this.setState( ()=>{
				return {
					enfantsAyantRessources : false,
					listeIndividus : enfantsAyantRessources
				}
			})
		}
	}

	getInfoRessource = ()=>{
		const infoSalaire = "Concernant votre salaire (dont prime et indemnité de fin de contrat)";
		const infoAllocation="Si vous percevez des allocations chômage";
		const infoIndemnite = "Si vous percevez des indemnités maladies";		
		const infoPension= "Si vous percevez une pension de retraite";

		let infoRessource =null;
		switch ( this.state.currentRessIndex ) {
			case 0 :
				infoRessource = infoSalaire;
				break;
			case 1 :
				infoRessource = infoAllocation;
				break;
			case 2 :
				infoRessource = infoIndemnite;
				break;
			case 3 :
				infoRessource = infoPension;
				break;
			default :
				break;  
		}

		if (infoRessource === null ) {
			return null;
		}		
		return <p>{infoRessource} , indiquez les montants nets AVANT prélèvement à la source ou d'éventuelles saisies. </p>
	}
	
	getRevenuForm = (ressource ,monthString)=>{
		if (!this.state.ressources[ressource.name].show){
			return '';
		}

		if ( ressource.name === 'tns_auto_entrepreneur_chiffre_affaires' ) {
			return this.formAutoEntrepreneur();
		} else if (ressource.name === 'tns_benefice_exploitant_agricole'){
			return this.formExploitantAgricole();
		} else if (ressource.name === 'tns_micro_entreprise_chiffre_affaires'){
			return this.formMicroEntreprise();
		} else if (ressource.name === 'tns_autres_revenus') {
			return this.formProfessionLiberale();
		}
		return  (this.state.ressources[ressource.name].show)?
						<div className="ressource-input-container fade-in">
							{(!this.state.ressources[ressource.name].details)?
								<div className="saisi-montant">
									
									<MontantInput 
										name = {ressource.name}
										model ={this.state.ressources[ressource.name][monthString]}
										modelName={ressource.name}
										handler={this.changeRessourceMontant}

									>
										Montant perçu chaque mois
									</MontantInput>
								</div>
							  : <div className="saisi-montant details">
							  		<MontantsDetailles
							  			name={ressource.name}
							  			modelName={ressource.name}
							  			handler= {this.captureMontantDetailler}
							  			single= {ressource.single}
							  		>
							  		</MontantsDetailles>
							  	</div>
							}
							<small className="detail-button"
								onClick={ (e) => (this.switchDetails(ressource.name))}
							>
								{(this.state.ressources[ressource.name].details) ?
									'Montant fixe perçu chaque mois'
								  : 'détaillez les montants sur les 12 derniers mois'}
							</small>
						</div>
						:''  ;
						
	}

	getTypeRevenusInterface = (revenus)=>{
		const infoRessource = this.getInfoRessource();
		const date = new Date();
		const monthString = date.getFullYear()+"-"+ ("0" + (date.getMonth()-1)).slice(-2);

		return <div className="ressource-form">
			<div className= "ress-left">
				<RadioBox
					name={revenus.name}
					options={{
						"Oui" : true, 
						"Non" : false,
					}}
					defaultValue ={this.state.switchTypeRessource[revenus.name]}
					modelName ={revenus.name}
					handler ={this.handleRadioSwitch}
				><>
					<h3 className="question-ressource ">
						{(['demandeur', 'conjoint'].includes(this.state.currentIndividu))?
							this.state.questionPersonne[this.state.currentIndividu]
							: (this.state.personnesACharge[this.state.currentIndividu].name)+ " perçoit-il·elle "
						} {revenus.question}
					</h3>
					<p className="indicationMontant">Saisir les montants nets versés en France comme à l’étranger depuis {this.dateNmoins1} 
						{ infoRessource !== null && revenus.name !=='revenu_pro_non_salarie' ?  <strong><InfoBulle message={infoRessource}  /> </strong>: ''}</p>
				</>
				</RadioBox>
			</div>
			<div className="ress-right">
				{(this.state.switchTypeRessource[revenus.name])?
					revenus.ressources.map( (ressource)=>(<div className="zone-ressource">
						<div className="ressource-label" onClick={()=>(this.showRessourceInput(ressource.name))}>{ressource.label}
						<span className= { 'fa '+ (!this.state.ressources[ressource.name].show ? 'fa-chevron-up' : 'fa-chevron-down')}> </span></div>

						{this.getRevenuForm(ressource ,monthString)}
									
					</div>
				)): ''}
			</div>
		</div>;
	}

	//
	typeRessourceForm = (currentRessIndex) =>{
		const currentRessType = this.state.typeRessources[currentRessIndex];
		const revenus= listeRessources[currentRessType];


		return (currentRessIndex === 0) ? <>
			{this.getTypeRevenusInterface(revenus)}
			{this.getTypeRevenusInterface(listeRessources['revenu_pro_non_salarie'])}
		</> : 
		this.getTypeRevenusInterface(revenus)  ;
	}

	questionRessourcesEnfants = ()=>{
		const months = [
		  'janvier',
		  'février',
		  'mars',
		  'avril',
		  'mai',
		  'juin',
		  'juillet',
		  'aout',
		  'septembre',
		  'octobre',
		  'novembre',
		  'décembre'
		];
		const month = months[new Date().getMonth()];
		const previousYear = (new Date().getFullYear()) - 1;
		return <div className="question-ressources-enfants">
			{ Object.keys(this.state.personnesACharge).map((individu,i)=>{
				
					return <RadioBox
					name={'revenu_enfant_'+i}
					options={{
						"Oui" : true, 
						"Non" : false,
					}}
					handler ={this.enfantRessourceSwitch}
					defaultValue={this.state.personnesACharge[individu].hasRessources}
					modelName={individu}
				><h3>{this.state.personnesACharge[individu].name} a-t-il·elle perçu des ressources depuis {month} {previousYear} ?</h3></RadioBox>;
				
			})}
			<button onClick={this.submitEnfantsAyantsRessources} >Valider</button>
		</div>;
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = ()=> {
		this.props.restart();
	}
	render() {
		return <div className="step-inner-container etape-ressources">
			{(!this.state.enfantsAyantRessources) ?<>
				<div className="etape-ressources-top">
					<div className="prev-btn-container">
				{ (this.state.currentRessIndex > 0) ?
					<button onClick={this.prevRessources} className="btn-previous"><img className="img-previous" src={arrowLeft}/>Précedent</button>
					:''
				}
				</div>
					<h2>
					{(['demandeur','conjoint'].includes(this.state.currentIndividu ))?
						({ 
							"demandeur":"Vos Ressources",
							"conjoint":"Les ressources de votre conjoint",
						})[this.state.currentIndividu]
						: "Les ressources de "+ (this.state.personnesACharge[this.state.currentIndividu].name).toLowerCase()
					}
					</h2>
				</div>
				
				{this.typeRessourceForm(this.state.currentRessIndex)}
				<div className ="error-container">
					<FormError errors = {[this.state.ressourceInputError]}/>
				</div>
				<button onClick={this.nextForm} className="ressource-validate">Valider</button>
				<div className="button-container previous">
					<button onClick={this.restart}> Recommencer </button>
				</div>
			</>: this.questionRessourcesEnfants()
			}

		</div>
	}
}

export default Ressources;